// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2BVT1","col":"styles_col__3j4NE"};